import { ApiService } from "../../constants/ApiService";
import { HttpService } from "../../constants/HTTPService";
import { DeletePreventiveMEDto, PreventiveMEDto } from "./Dto";
import { PreventiveMEEntity } from "./Entity";

export const getPreventiveMEListMock = async (): Promise<
  PreventiveMEEntity[]
> =>
  //   const dataAPI = await HttpService.get("/");

  // return dataAPI.data.data;
  [
    {
      id: "PM0001",
      name: "Logsheet KWH",
      link: "https://adriantowijaya.vercel.app/",
      location: "LC0001",
      type: "DAILY",
    },
    {
      id: "PM0002",
      name: "Laporan Pekerjaan",
      link: "https://adriantowijaya.vercel.app/",
      location: "LC0001",
      type: "QUARTERLY",
    },
    {
      id: "PM0003",
      name: "Pemakaian Material Gudang",
      link: "https://adriantowijaya.vercel.app/",
      location: "LC0002",
      type: "DAILY",
    },
    {
      id: "PM0004",
      name: "Running Genset",
      link: "https://adriantowijaya.vercel.app/",
      location: "LC0002",
      type: "QUARTERLY",
    },
    {
      id: "PM0005",
      name: "AC Split Duct",
      link: "https://adriantowijaya.vercel.app/",
      location: "LC0001",
      type: "DAILY",
    },
  ];

export const getPreventiveMEDetailMock = async (
  id: string
): Promise<PreventiveMEEntity> =>
  //   const dataAPI = await HttpService.get("/");

  // return dataAPI.data.data;
  ({
    id: "PM0001",
    name: "Logsheet KWH",
    link: "https://adriantowijaya.vercel.app/",
    location: "LC0002",
    type: "QUARTERLY",
  });

export const createPreventiveME = async (
  payload: PreventiveMEDto
): Promise<boolean> => {
  try {
    await HttpService.post(
      ApiService.preventiveME.createPreventiveME,
      JSON.stringify(PreventiveMEDto.toCreateJSON(payload))
    );
    return true;
  } catch (error) {
    console.error("Error creating form:", error);
    throw new Error("Failed to create preventive ME");
  }
};

export const getPreventiveMEList = async (
  locationId: string
): Promise<PreventiveMEEntity[]> => {
  try {
    const response = await HttpService.get(
      `${ApiService.preventiveME.getPreventiveME}/${locationId}`
    );
    return PreventiveMEEntity.fromArrayJSON(response.data.data);
  } catch (error) {
    console.error("Error fetching form:", error);
    throw new Error("Failed to fetch preventive ME list");
  }
};

export const getPreventiveMEDetail = async (
  preventiveMEID: string
): Promise<PreventiveMEEntity> => {
  try {
    const response = await HttpService.get(
      `${ApiService.preventiveME.getPreventiveMEDetail}/${preventiveMEID}`
    );
    return PreventiveMEEntity.fromJSON(response.data.data);
  } catch (error) {
    console.error("Error fetching form:", error);
    throw new Error("Failed to fetch preventive ME detail");
  }
};

export const deletePreventiveME = async (
  payload: DeletePreventiveMEDto
): Promise<boolean> => {
  try {
    await HttpService.post(
      ApiService.preventiveME.deletePreventiveME,
      JSON.stringify(payload)
    );
    return true;
  } catch (error) {
    console.error("Error deleting form:", error);
    throw new Error("Failed to delete preventive ME");
  }
};

export const updatePreventiveME = async (
  payload: PreventiveMEDto
): Promise<boolean> => {
  try {
    await HttpService.post(
      ApiService.preventiveME.updatePreventiveME,
      JSON.stringify(PreventiveMEDto.toUpdateJSON(payload))
    );
    return true;
  } catch (error) {
    console.error("Error updating form:", error);
    throw new Error("Failed to update preventive ME");
  }
};
